(function () {
  'use strict';

  angular.module('wsLrs.controllers').config(['$routeProvider', function ($routeProvider) {
    $routeProvider
    // Fallback routes to protect against an older email trying to click "unsubscribe"
    // after we've changed the routes. Since we're certain those will only be shares, we
    // can just hard-code the "shares" value.
    .when('/unsubscribe-scheduled-report', {
      redirectTo: function redirectTo() {
        return "/automated-emails/unsubscribe/shares";
      }
    }).when('/accept-scheduled-report', {
      redirectTo: function redirectTo() {
        return "/automated-emails/accept-subscription/shares";
      }
    }).when('/automated-emails/:actionType?/:type?', {
      templateUrl: 'modules/outside/automated-email-subscription/auto-email-template.html',
      controller: 'AutoEmailSubscriptionCtrl'
    });
  }]).
  /**
   * For the controllers below:
   * @param $routeParams.type {String} is always "shares" by default, but can be "workflows"
   * @param actionType {String} can be either: 'accept-subscription' or 'unsubscribe' it defines both the API call
   *          and the behavior we expect from the controller (i.e. subscribeError or unsubscribeError)
   */

  controller('AutoEmailSubscriptionCtrl', ['$scope', '$routeParams', '$http', 'Api', 'wsConfig', '$location', function ($scope, $routeParams, $http, Api, wsConfig, $location) {
    var actionType = $routeParams.actionType;
    if (!actionType) {
      throw new Error('Must define "actionType" in route');
    }
    if (actionType !== 'accept-subscription' && actionType !== 'unsubscribe') {
      throw new Error("actionType must be one of: \"accept-subscription\" || \"unsubscribe\". It is: ".concat(actionType));
    }

    // Type can be: 'shares' || 'workflows'
    $scope.type = $routeParams.type || 'shares';
    if (!$scope.type) {
      throw new Error('Must defined "type" in route');
    }
    if ($scope.type !== 'workflows' && $scope.type !== 'shares') {
      throw new Error("type must be one of: \"workflows\" or \"shares\". It is: (".concat($scope.type, ")"));
    }
    $scope.isWorkflow = $scope.type === 'workflows';
    $scope.isShare = $scope.type === 'shares';
    var token = $location.search().token;
    $scope.email = $location.search().email;
    $scope.shareKey = $location.search().shareKey;
    $scope.workflowId = $location.search().workflowId;
    $scope.orgId = $location.search().orgId;
    var shareHasNoKey = $scope.isShare && !$scope.shareKey;
    if (shareHasNoKey) {
      throw new Error('Share must have shareKey defined');
    }
    var workflowMissingData = $scope.isWorkflow && (!$scope.workflowId || !$scope.orgId);
    if (workflowMissingData) {
      throw new Error('Workflow must have both a workflowId and an orgId');
    }

    // Token & email needed regardless of type
    // actionType is resolved in the route and defines what API call we should make: are we subscribing
    // or are we unsubscribing and from what resource are we subscribing/unsubscribing.
    var url = "".concat($scope.type, "/").concat(actionType, "?token=").concat(encodeURIComponent(token), "&email=").concat(encodeURIComponent($scope.email));

    // If workflow, append workflowId and make sure it's tenant-bound
    // Using Api.url(<>, false) will not work because we're not guaranteed to have a user in this context
    // so we use the OrgId passed from the server in the routeParams above.
    if ($scope.isWorkflow) {
      url = "organizations/".concat($scope.orgId, "/").concat(url, "&workflowId=").concat(encodeURIComponent($scope.workflowId));
    }

    // If share, append shareKey
    if ($scope.isShare) {
      url = "".concat(url, "&shareKey=").concat(encodeURIComponent($scope.shareKey));
    }
    $http.post(Api.url(url, true), {}).then(function success(response) {
      if (actionType === 'accept-subscription') {
        $scope.subscribed = true;
      } else if (actionType === 'unsubscribe') {
        $scope.unsubscribed = true;
      }
      if ($scope.isShare) {
        $scope.share = response.data;
      }
      if ($scope.isWorkflow) {
        $scope.workflow = response.data;
      }
    }, function error(response) {
      if (actionType === 'accept-subscription') {
        $scope.subscribeError = response.data.message;
      } else if (actionType === 'unsubscribe') {
        $scope.unsubscribeError = response.data.message;
      }
    });
  }]);
})();
